import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { getAuthToken } from '../../utils/storage';

const axiosNest: AxiosInstance = axios.create({
  baseURL: `${import.meta.env.VITE_SERVER_NESTJS_API_URL}/api`,
  withCredentials: true,
});

axiosNest.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const accessToken = getAuthToken();
  if (accessToken && config.headers) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  config.withCredentials = true;
  return config;
});

axiosNest.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default axiosNest;
